<template>
  <v-avatar
    v-if="round"
    :image="src"
    :size="size"
  />
  <v-img
    v-else
    :src="src"
    :alt="alt"
    :contain="contain"
    :cover="cover"
    :height="height"
  />
</template>

<script setup lang="ts">
//================= [CSS] =====================================

//================= [JS] ======================================

//================= [VUE COMPONENTS] ==========================
import {onMounted, ref, watch} from 'vue';
import {BaseApi} from '@/common/api/BaseApi';
import {useStore} from '@/common/store/store';

const store = useStore();

const props = withDefaults(defineProps<{
  file: string,
  mimeType: string,
  contain?: boolean,
  cover?: boolean,
  height?: string | number,
  path?: string | null,
  size?: number,
  round?: boolean,
  cuId?: string,
  // Leerer Alt-Text = dekoratives Bild. Aufrufer, bei denen das Bild Inhalt
  // trägt, geben eine Beschreibung mit.
  alt?: string,
}>(), {
  contain: true,
  cover: false,
  height: undefined,
  path: null,
  size: 200,
  round: false,
  cuId: undefined,
  alt: '',
});

const src = ref('');
watch(() => props.file, (value) => {
  if (!value) {
    src.value = '';
    return;
  }
  const customerId = props.cuId !== undefined && props.cuId !== null ? props.cuId : store.userData?.customer;
  src.value = `${BaseApi.IMAGE_URL}/files/${customerId}/${getFolder()}/${getValueName(value)}`;
});

const getFolder = () => {
  let folder = 'image';
  if (props.mimeType?.includes('video')) {
    folder = 'video';
  }
  if (props.mimeType?.includes('pdf')) {
    folder = 'pdf';
  }

  if (props.path !== null) {
    folder = props.path;
  }

  return folder;
};

const getValueName = (value: string | null | undefined) => {
  if (!value) {
    return '';
  }
  let valueName = value.replace(' ', '_');
  if (props.mimeType?.includes('video') || props.mimeType?.includes('pdf')) {
    const valueNameSplit = valueName.split('.');
    valueNameSplit.pop();
    valueName = valueNameSplit.join('.');
    valueName = `${valueName}_preview.jpg`;
  }
  return valueName;
};

onMounted(() => {
  if (!props.file) {
    return;
  }
  const customerId = props.cuId !== undefined && props.cuId !== null ? props.cuId : store.userData?.customer;
  src.value = `${BaseApi.IMAGE_URL}/files/${customerId}/${getFolder()}/${getValueName(props.file)}`;
});
</script>

<style scoped lang="scss">

</style>
